import React from 'react';
import { Card, CardContent } from '../../../../../../components/ui/card';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../../../../../../components/ui/table';
import { Edit, ChevronLeft, ChevronRight } from 'lucide-react';
import { cn } from '../../../../../../lib/utils';
import { Materials } from '../../../../types/materials';
import { Button } from '../../../../../../components/ui/button';

interface WireTabProps {
  materials: Materials[];
  selectedPipeSize: number;
  currentPage: number;
  materialsPerPage: number;
  onPageChange: (page: number) => void;
}

export const WireTab: React.FC<WireTabProps> = ({
  materials,
  selectedPipeSize,
  currentPage,
  materialsPerPage,
  onPageChange,
}) => {
  const filteredMaterials = materials.filter(
    m => m.category === 'Wire Lot' && m.pipeId === `pipe-${selectedPipeSize}`
  );

  return (
    <Card>
      <CardContent className="p-4">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Lot Number</TableHead>
              <TableHead>Status</TableHead>
              <TableHead>Assembly Numbers</TableHead>
              <TableHead>Actions</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {filteredMaterials
              .slice((currentPage - 1) * materialsPerPage, currentPage * materialsPerPage)
              .map((wire) => (
                <TableRow key={wire.id}>
                  <TableCell>{wire.lotNumber}</TableCell>
                  <TableCell>
                    <span className={cn(
                      "px-2 py-1 text-xs rounded-full",
                      wire.status === 'Available' && "bg-green-100 text-green-800",
                      wire.status === 'Consumed' && "bg-gray-100 text-gray-800"
                    )}>
                      {wire.status}
                    </span>
                  </TableCell>
                  <TableCell>
                    {wire.status === 'Consumed' ?
                      wire.assemblyNumbers?.join(', ') || '-' :
                      '-'
                    }
                  </TableCell>
                  <TableCell>
                    <Button
                      onClick={() => { }}
                      className="text-blue-600 hover:text-blue-800 opacity-50"
                      title="Edit Material"
                      variant="outline"
                    >
                      <Edit className="h-4 w-4" />
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>

        {/* Pagination */}
        <div className="flex items-center justify-between mt-4">
          <p className="text-sm text-gray-500">
            Showing {((currentPage - 1) * materialsPerPage) + 1} to {Math.min(currentPage * materialsPerPage, filteredMaterials.length)} of {filteredMaterials.length}
          </p>
          <div className="flex items-center gap-2">
            <Button
              onClick={() => onPageChange(Math.max(1, currentPage - 1))}
              disabled={currentPage === 1}
              className="p-1 rounded hover:bg-gray-100 disabled:opacity-50"
              title="Previous Page"
              variant="outline"
            >
              <ChevronLeft className="h-5 w-5" />
            </Button>
            <span className="text-sm">{currentPage}</span>
            <Button
              onClick={() => onPageChange(currentPage + 1)}
              disabled={currentPage * materialsPerPage >= filteredMaterials.length}
              className="p-1 rounded hover:bg-gray-100 disabled:opacity-50"
              title="Next Page"
              variant="outline"
            >
              <ChevronRight className="h-5 w-5" />
            </Button>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}; 